import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getFullImageUrl } from '../utils/api';

const AuthenticatedImage = ({ src, alt, ...props }) => {
  const [error, setError] = useState(false);

  if (!src) {
    return <div style={{height: '100%', width: '100%', background: '#f8f8f8'}} />;
  }

  if (error) {
    return (
      <div style={{height: '100%', width: '100%', background: '#eee', color: '#888', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        Image unavailable
      </div>
    );
  }

  const fullUrl = getFullImageUrl(src);

  return (
    <img
      src={fullUrl}
      alt={alt}
      onError={() => setError(true)}
      {...props}
    />
  );
};

AuthenticatedImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default AuthenticatedImage;
